import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, GridUpdateMessage, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import CategoryForm from './forms/category-form';
import { getTableParams } from './grid.params';

export const CategoryGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, updateEntry } = props;
  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});

  const { t } = useTranslation();

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('vehicle_category.update');
  const rightAdd = user.haveRight('vehicle_category.add');
  const actions = [];

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (count) {
    getXlsAction(topActions);
  }

  const initial = showForm === 'addForm' ? {} : { ...row };
  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('category', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Категории')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
        updateEntry={updateEntry}
      />

      {showForm && <CategoryForm type={showForm} close={() => setShowForm('')} id={row.id} setMessage={setMessage} refresh={props.refresh} initialValues={initial} />}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
